import { Order } from "@/types/Order.interface";
import { createSlice } from "@reduxjs/toolkit";
import { cartOfferCases } from "../extra/cases/cart/cartOfferCases";
import { CartProduct } from "@/widgets/ProductCard/types/productCard.interface";
import { addToCartCases } from "../extra/cases/cart/addToCartCases";

export interface CartState {
    miniCart: Order | null;
    cartOffer: Order | null;
    addedCartElement: CartProduct | null;
    loading: {
        miniCart: boolean;
        cartOffer: boolean;
        addedCartElement: boolean;
    };
    error: {
        miniCart: any;
        cartOffer: any;
        addedCartElement: any;
    };
}

const initialState: CartState = {
    miniCart: null,
    cartOffer: null,
    addedCartElement: null,
    loading: {
        miniCart: false,
        cartOffer: false,
        addedCartElement: false,
    },
    error: {
        miniCart: null,
        cartOffer: null,
        addedCartElement: null,
    },
};

//Слайс данные корзины пользователя
const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        /** Установка добавленного элемента в корзину */
        setAddedCartElement: (state, action) => {
            state.addedCartElement = action.payload;
        },
    },
    extraReducers: (builder) => {
        cartOfferCases(builder);
        addToCartCases(builder);
    }
});

export const { setAddedCartElement } = cartSlice.actions;

export default cartSlice.reducer;
